// TODO: Shared with SLW in satellite-components
export const getValueFromEnum = <T extends Record<string, string>>(
  item: string | null | undefined,
  enumType: T,
): T[keyof T] | undefined => {
  return item && Object.values(enumType).includes(item) ? (item as T[keyof T]) : undefined;
};
